import React, { useState, useRef } from 'react';
import { ZoomIn } from 'lucide-react';

export const ZoomImage = ({ src, alt, className = "" }) => {
  const [isZoomed, setIsZoomed] = useState(false);
  const [isHovering, setIsHovering] = useState(false);
  const [position, setPosition] = useState({ x: 50, y: 50 });
  const imageRef = useRef(null);

  const handleMouseMove = (e) => {
    if (!imageRef.current) return;
    
    const rect = imageRef.current.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    
    setPosition({ x, y });
  };

  const handleMouseEnter = () => {
    setIsHovering(true);
    setIsZoomed(true);
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
    setIsZoomed(false);
  };

  return (
    <div 
      ref={imageRef}
      className={`relative overflow-hidden ${className}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onMouseMove={handleMouseMove}
    >
      <img
        src={src}
        alt={alt}
        className="w-full h-full object-cover transition-all duration-300 ease-out"
        style={{
          transform: isZoomed ? 'scale(2)' : 'scale(1)',
          transformOrigin: `${position.x}% ${position.y}%`
        }}
      />
      
      {/* Tap to Zoom Overlay */}
      <div 
        className={`absolute inset-0 bg-black/40 backdrop-blur-[2px] flex items-center justify-center transition-opacity duration-300 ${
          isHovering && !isZoomed ? 'opacity-100' : 'opacity-0'
        }`}
      >
        <div className="flex flex-col items-center gap-2 text-white">
          <ZoomIn className="h-8 w-8" />
          <span className="font-montserrat text-sm tracking-wider uppercase">Tap to Zoom</span>
        </div>
      </div>
      
      {/* Zoom Indicator when zoomed */}
      {isZoomed && (
        <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full shadow-lg animate-in fade-in duration-200">
          <span className="font-montserrat text-xs text-[#2C2C2C] tracking-wider uppercase flex items-center gap-1">
            <ZoomIn className="h-3 w-3" />
            Zoomed 2x
          </span>
        </div>
      )}
    </div>
  );
};
